// src/components/CountdownManager.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCountdownStore } from "../../store/useCountdownStore";

export const CountdownManager = () => {
  const navigate = useNavigate();
  const { isActive, secondsLeft, targetPath, tick, stopCountdown } =
    useCountdownStore();

  // Tick every second while active
  useEffect(() => {
    if (!isActive) return;

    const id = setInterval(() => {
      tick();
    }, 1000);

    return () => clearInterval(id);
  }, [isActive, tick]);

  // Navigate when done
  useEffect(() => {
    if (isActive && secondsLeft <= 0 && targetPath) {
      navigate(targetPath, { replace: true });
      stopCountdown();
    }
  }, [isActive, secondsLeft, targetPath, navigate, stopCountdown]);

  // This component doesn't render UI
  return null;
};
